import { authServiceRequest } from './baseAPI';

export const endpointAPI = {
  getAll: async () => {
    console.log(`Calling GET /api/admin/endpoints (direct auth service)`);
    try {
      const response = await authServiceRequest('/endpoints');
      console.log(`GET /api/admin/endpoints response:`, response);
      return response;
    } catch (error) {
      console.error(`GET /api/admin/endpoints error:`, error);
      throw error;
    }
  },
  
  create: async (data) => {
    console.log(`Calling POST /api/admin/endpoints (direct auth service) with data:`, data);
    try {
      const response = await authServiceRequest('/endpoints', {
        method: 'POST',
        data: {
          baseUrl: data.baseUrl,
          name: data.name
        }
      });
      console.log(`POST /api/admin/endpoints response:`, response);
      return response;
    } catch (error) {
      console.error(`POST /api/admin/endpoints error:`, error);
      throw error;
    }
  },

  delete: async (endpointId) => {
    console.log(`Calling DELETE /api/admin/endpoints/${endpointId} (direct auth service)`);
    try {
      const response = await authServiceRequest(`/endpoints/${endpointId}`, {
        method: 'DELETE'
      });
      console.log(`DELETE /api/admin/endpoints/${endpointId} response:`, response);
      return response;
    } catch (error) {
      console.error(`DELETE /api/admin/endpoints/${endpointId} error:`, error);
      throw error;
    }
  },
  
  getServiceStatus: async () => {
    console.log(`Calling GET /api/admin/service-status (direct auth service)`);
    try {
      const response = await authServiceRequest('/service-status');
      console.log(`GET /api/admin/service-status response:`, response);
      return response;
    } catch (error) {
      console.error(`GET /api/admin/service-status error:`, error);
      throw error;
    }
  },
  
  update: async (endpointId, data) => {
    console.log(`Calling PUT /api/admin/endpoints/${endpointId} (direct auth service) with data:`, data);
    try {
      const requestData = {};
      if (data.baseUrl !== undefined) requestData.baseUrl = data.baseUrl;
      if (data.name !== undefined) requestData.name = data.name;
      if (data.description !== undefined) requestData.description = data.description;
      if (data.defaultProtocol !== undefined) requestData.defaultProtocol = data.defaultProtocol;
      if (data.environment !== undefined) requestData.environment = data.environment;
      if (data.isActive !== undefined) requestData.isActive = data.isActive;
      if (data.tags !== undefined) requestData.tags = data.tags;
      
      const response = await authServiceRequest(`/endpoints/${endpointId}`, {
        method: 'PUT',
        data: requestData
      });
      console.log(`PUT /api/admin/endpoints/${endpointId} response:`, response);
      return response;
    } catch (error) {
      console.error(`PUT /api/admin/endpoints/${endpointId} error:`, error);
      throw error;
    }
  }
}; 